import React, { useState, useMemo, useEffect, } from "react";
import { connect,useSelector } from "react-redux";
import { userRegister } from "../../actions/loginAction";
import { getAllUsers } from "../../actions/loginAction";
import { setPatientProfile } from "../../actions/patientProfileActions";
import { createAppointment } from "../../actions/appointmentActions";
import { getScheduleData } from "../../actions/scheduleActions";
import { getAllAppointments } from "../../actions/appointmentActions";
import { getAllPatientProfiles } from "../../actions/patientProfileActions";
import { getDoctorProfileById } from "../../actions/doctorActions";
import { getAccountStatus } from "../../actions/businessModuleActions";
import MessageModal from "../Pages/MessageModel";
import { getBusinessAddons } from "../../actions/businessAddonActions";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
// Helper functions for time calculation
const getWeekDatesFromOffset = (offset) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const startDate = new Date();
  const dayOfWeek = startDate.getDay();
  const diff = startDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
  startDate.setDate(diff + offset * 7);

  return Array.from({ length: 7 }, (_, i) => {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i);
    date.setHours(0, 0, 0, 0);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const fullDateStr = `${year}-${month}-${day}`;

    return {
      dayName: date
        .toLocaleDateString("en-US", { weekday: "short" })
        .toUpperCase(),
      dateStr: `${date.getDate().toString().padStart(2, "0")} ${date.toLocaleDateString("en-US", { month: "short" }).toUpperCase()}`,
      year: date.getFullYear(),
      fullDate: fullDateStr,
      dayIndex: date.getDay(),
      isPast: date < today,
    };
  });
};

const convertToMinutes = (timeStr12h) => {
  if (!timeStr12h) return null;
  const parts = timeStr12h.match(/(\d+):(\d+)\s(AM|PM)/);
  if (!parts) return null;
  let [, hour, minute, period] = parts;
  hour = parseInt(hour, 10);
  minute = parseInt(minute, 10);
  if (period === "PM" && hour !== 12) hour += 12;
  if (period === "AM" && hour === 12) hour = 0;
  return hour * 60 + minute;
};

const isTimeOverlapping = (slotMinutes, blockerMinutes) => {
  if (
    !slotMinutes ||
    !blockerMinutes ||
    slotMinutes.start === null ||
    slotMinutes.end === null ||
    blockerMinutes.start === null ||
    blockerMinutes.end === null
  )
    return false;
  const noOverlap =
    slotMinutes.end <= blockerMinutes.start ||
    slotMinutes.start >= blockerMinutes.end;
  return !noOverlap;
};

// Self Appointment Tab Component
const SelfAppointmentTab = ({
  initialPatientId,
  hospitalCode,
  templateSlots,
  daysOff,
  blockers,
  bookedAppointments,
  userList,
  userRegister,
  getAllUsers,
  setPatientProfile,
  createAppointment,
  getScheduleData,
  getAllAppointments,
  getAllPatientProfiles,
  isCreatingAppointment,
  getDoctorProfileById,
  doctorProfile,
  getAccountStatus,
  getBusinessAddons,
  accountStatus,
}) => {
  const [weekOffset, setWeekOffset] = useState(0);
  const [selectedDateInfo, setSelectedDateInfo] = useState(null);
  const [selectedSlots, setSelectedSlots] = useState([]); // Array for multiple slots
  const [appointmentType, setAppointmentType] = useState("Direct");
  const [showPatientForm, setShowPatientForm] = useState(false);
  const [isCreatingPatient, setIsCreatingPatient] = useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [patientSearchTerm, setPatientSearchTerm] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [editableFee, setEditableFee] = useState("0");
  const { businessAddons } = useSelector((state) => state.businessAddons);
  // Patient registration state
  const [registrationComplete, setRegistrationComplete] = useState(false);
  const [newlyRegisteredEmail, setNewlyRegisteredEmail] = useState(null);
  const history = useHistory();
  const [showAddonModal, setShowAddonModal] = useState(false);
  const [missingAddonName, setMissingAddonName] = useState("");

  // Patient form state
  const [patientData, setPatientData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  // Addon access state
  const [hasSelfAppointmentAccess, setHasSelfAppointmentAccess] =
    useState(false);
  const [subscriptionChecked, setSubscriptionChecked] = useState(false);
  const [checkingAccess, setCheckingAccess] = useState(true);
  const hasSelfAppointmentAddon = businessAddons?.some(
  (addon) => addon.addon_name === "Self Appointment" && addon.status?.toLowerCase() === "active"
);
const hasVideoAddon = businessAddons?.some(
  (addon) => addon.addon_name === "Video" && addon.status?.toLowerCase() === "active"
);

const hasHomeVisitAddon = businessAddons?.some(
  (addon) => addon.addon_name === "Home Visite" && addon.status?.toLowerCase() === "active"
);
  const weekDays = useMemo(
    () => getWeekDatesFromOffset(weekOffset),
    [weekOffset],
  );

  // Check if self appointment addon is available in active modules
const checkSelfAppointmentAccess = async () => {
  try {
    const userRole = localStorage.getItem("userRole");
    
    // Agar user Admin nahi hai, toh access grant karein
    if (userRole?.toLowerCase() !== "admin") {
      setHasSelfAppointmentAccess(true);
    } else {
      // Admin ke liye hum hasSelfAppointmentAddon variable use karenge niche
      setHasSelfAppointmentAccess(true); 
    }
    
    setSubscriptionChecked(true);
    setCheckingAccess(false); // Yeh line loading band karegi
  } catch (error) {
    console.error("Error checking access:", error);
    setCheckingAccess(false);
  }
};
  useEffect(() => {
    if (initialPatientId) {
      setSelectedPatientId(String(initialPatientId));
    }
  }, [initialPatientId]);
  // Load schedule data, users, doctor profile and check access when component mounts
//  useEffect(() => {
//     if (hospitalCode) {
//       getBusinessAddons(hospitalCode); // API call trigger yahan se hoga
//       getScheduleData({ hospitalID: parseInt(hospitalCode) });
//       getAllUsers();
//       getDoctorProfileById(hospitalCode);
//     }
//   }, [hospitalCode, getBusinessAddons, getScheduleData, getAllUsers, getDoctorProfileById]);
useEffect(() => {
  // Access check call karein
  checkSelfAppointmentAccess();

  if (hospitalCode) {
    // Saari API calls ek saath
    const loadData = async () => {
      await getBusinessAddons(hospitalCode);
      getScheduleData({ hospitalID: parseInt(hospitalCode) });
      getAllUsers();
      getDoctorProfileById(hospitalCode);
    };
    loadData();
  }
}, [hospitalCode]); // Dependency array ko chota rakhein loop se bachne ke liye
  useEffect(() => {
  if (doctorProfile) {
    if (appointmentType === "Direct") setEditableFee(doctorProfile.PricingOffline || "0");
    else if (appointmentType === "Video") setEditableFee(doctorProfile.PricingVideo || "0");
    else if (appointmentType === "Home") setEditableFee(doctorProfile.HomeVisitPricingOnline || "0");
  }
}, [appointmentType, doctorProfile]);
  // Get appointment fee based on type from doctor profile
  const getAppointmentFee = () => {
    if (!doctorProfile) return "0";

    switch (appointmentType) {
      case "Direct":
        return doctorProfile.PricingOffline || "0";
      case "Video":
        return doctorProfile.PricingVideo || "0";
      case "Home": // Naya case add kiya
      return doctorProfile.HomeVisitPricingOnline || "0";
      default:
      return "0";
    }
  };

  // Handle user registration completion and profile creation
  useEffect(() => {
    if (isCreatingPatient && registrationComplete && userList) {
      const findAndCreateProfile = async () => {
        try {
          await getAllUsers();
          await new Promise((resolve) => setTimeout(resolve, 1500));

          const newRegisteredUser = userList.find(
            (user) => user && user.email === newlyRegisteredEmail,
          );

          if (!newRegisteredUser) {
            setSuccessMessage(
              "Patient registration succeeded, but the new user could not be found to create a profile. Please try again.",
            );
            setIsCreatingPatient(false);
            setRegistrationComplete(false);
            return;
          }

          const hospitalId =
            newRegisteredUser.hospitalID || newRegisteredUser.id;

          if (!hospitalId) {
            setSuccessMessage(
              "Found user, but their data is incomplete (missing hospitalID).",
            );
            setIsCreatingPatient(false);
            setRegistrationComplete(false);
            return;
          }

          const patientProfileData = {
            PatientID: hospitalId,
            uploadPhoto: "",
            email: newRegisteredUser.email,
            firstName: newRegisteredUser.first_name || patientData.firstName,
            lastName: newRegisteredUser.last_name || patientData.lastName,
            phoneNumber: newRegisteredUser.mobile || patientData.phoneNumber,
            dateOfBirth: "",
            bloodGrp: "",
            address: "",
            city: "",
            state: "",
            postalCode: "",
            country: "",
          };

          await setPatientProfile(patientProfileData);

          setPatientData({
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
          });
          setShowPatientForm(false);
          setSuccessMessage(
            "Patient created successfully! You can now book an appointment.",
          );

          await getAllPatientProfiles();
          await getAllUsers();

          setRegistrationComplete(false);
          setNewlyRegisteredEmail(null);
        } catch (profileError) {
          setSuccessMessage(
            "Patient account created but profile creation failed. You can still book appointment for this patient.",
          );
          setShowPatientForm(false);
          setIsCreatingPatient(false);
          setRegistrationComplete(false);
        } finally {
          setIsCreatingPatient(false);
        }
      };

      findAndCreateProfile();
    }
  }, [
    isCreatingPatient,
    registrationComplete,
    userList,
    newlyRegisteredEmail,
    setPatientProfile,
    getAllPatientProfiles,
    getAllUsers,
    patientData,
  ]);

  // Get patients from user list (users with role 'Patient')
  const patientUsers = useMemo(() => {
    if (!userList || !Array.isArray(userList)) return [];

    return userList.filter(
      (user) =>
        user &&
        user.role &&
        user.role.toLowerCase() === "patient" &&
        user.app_status !== "disabled",
    );
  }, [userList]);

  // Enhanced helper function for patient user display
  const getPatientUserDisplayInfo = (patientUser) => {
    if (!patientUser) return "No patient data";

    const name =
      `${patientUser.first_name || ""} ${patientUser.last_name || ""}`.trim() ||
      "Unknown Patient";
    const phone =
      patientUser.mobile ||
      patientUser.phoneNumber ||
      patientUser.phone ||
      "No Phone";
    const email = patientUser.email || "";
    const patientId =
      patientUser.hospitalID ||
      patientUser.id ||
      patientUser.PatientID ||
      "No ID";

    let displayText = `${name} `;

    return displayText;
  };

  // Get patient user ID
  const getPatientUserId = (patientUser) => {
    if (!patientUser) return null;
    return patientUser.hospitalID || patientUser.id || patientUser.PatientID;
  };


// Filter patients based on search term
  const filteredPatientUsers = useMemo(() => {
    if (!patientUsers) return [];
    
    const term = patientSearchTerm.toLowerCase().trim();
    if (!term) return patientUsers;

    return patientUsers.filter((user) => {
      const firstName = (user.first_name || "").toLowerCase();
      const lastName = (user.last_name || "").toLowerCase();
      const fullName = `${firstName} ${lastName}`;
      const mobile = (user.mobile || user.phoneNumber || user.phone || "").toLowerCase();
      const email = (user.email || "").toLowerCase();
      const id = String(user.hospitalID || user.id || "").toLowerCase();

      return (
        fullName.includes(term) ||
        mobile.includes(term) ||
        email.includes(term) ||
        id.includes(term)
      );
    });
  }, [patientUsers, patientSearchTerm]);

  // Calculate available slots
  const calculateSlotsForDay = useMemo(() => {
    return (dayInfo) => {
      if (
        !dayInfo ||
        !hospitalCode ||
        !templateSlots ||
        !daysOff ||
        !blockers ||
        !bookedAppointments
      )
        return [];

      const dayOrder = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      const dayOfWeekName = dayOrder[dayInfo.dayIndex];

      const currentDoctorId = String(hospitalCode);
      const doctorTemplateSlots = (templateSlots || []).filter(
        (s) => s && String(s.hospitalID) === currentDoctorId,
      );
      const doctorDaysOff = (daysOff || []).filter(
        (d) => d && String(d.hospitalID) === currentDoctorId,
      );
      const doctorBlockers = (blockers || []).filter(
        (b) => b && String(b.hospitalID) === currentDoctorId,
      );

      const isHoliday = doctorDaysOff.some(
        (d) => d.date && d.date.trim() === dayInfo.fullDate,
      );
      if (isHoliday) return [];

      const dayTemplateSlots = doctorTemplateSlots.filter(
        (s) => s.day === dayOfWeekName,
      );
      if (dayTemplateSlots.length === 0) return [];

      const dayBlockers = doctorBlockers.filter(
        (b) => b.date && b.date.trim() === dayInfo.fullDate,
      );
      const blockerRanges = dayBlockers
        .map((b) => ({
          start: convertToMinutes(b.slot && b.slot.split(" - ")[0]),
          end: convertToMinutes(b.slot && b.slot.split(" - ")[1]),
        }))
        .filter((b) => b.start !== null && b.end !== null);

      const dayBookedSlots = (bookedAppointments || []).filter(
        (app) =>
          app &&
          app.appointmentDate === dayInfo.fullDate &&
          String(app.hospitalID) === currentDoctorId,
      );

      return dayTemplateSlots.filter((slot) => {
        if (!slot || !slot.slot) return false;

        const slotRange = {
          start: convertToMinutes(slot.slot.split(" - ")[0]),
          end: convertToMinutes(slot.slot.split(" - ")[1]),
        };
        if (slotRange.start === null) return false;
        if (
          blockerRanges.some((blocker) => isTimeOverlapping(slotRange, blocker))
        )
          return false;
        if (
          dayBookedSlots.some((booked) => booked.appointmentTime === slot.slot)
        )
          return false;
        return true;
      });
    };
  }, [hospitalCode, templateSlots, daysOff, blockers, bookedAppointments]);

  const availableSlots = useMemo(() => {
    if (!selectedDateInfo) return [];
    return calculateSlotsForDay(selectedDateInfo).sort(
      (a, b) =>
        convertToMinutes(a.slot.split(" - ")[0]) -
        convertToMinutes(b.slot.split(" - ")[0]),
    );
  }, [selectedDateInfo, calculateSlotsForDay]);

  const categorizedSlots = useMemo(() => {
    const morning = [],
      afternoon = [],
      evening = [];
    (availableSlots || []).forEach((slot) => {
      if (!slot || !slot.slot) return;
      const startMinutes = convertToMinutes(slot.slot.split(" - ")[0]);
      if (startMinutes < 720) morning.push(slot);
      else if (startMinutes < 1020) afternoon.push(slot);
      else evening.push(slot);
    });
    return { morning, afternoon, evening };
  }, [availableSlots]);
  const toggleSlotSelection = (date, time) => {
    const slotId = `${date}-${time}`;
    const isAlreadySelected = selectedSlots.some(
      (s) => `${s.date}-${s.time}` === slotId,
    );

    if (isAlreadySelected) {
      setSelectedSlots(
        selectedSlots.filter((s) => `${s.date}-${s.time}` !== slotId),
      );
    } else {
      setSelectedSlots([...selectedSlots, { date, time }]);
    }
  };
  const handleTypeSelection = (type, hasAccess) => {
    if (!hasAccess) {
      setMissingAddonName(type === "Video" ? "Video Consultation" : "Home Visit");
      setShowAddonModal(true);
      return;
    }
    setAppointmentType(type);
  };
  const handlePatientInputChange = (field, value) => {
    setPatientData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCreatePatient = async () => {
    if (!hasSelfAppointmentAccess) {
      alert(
        "Self Appointment feature is not available. Please subscribe to the Self Appointment addon package to create patients and book appointments.",
      );
      return;
    }

    if (
      !patientData.firstName ||
      !patientData.lastName ||
      !patientData.phoneNumber
    ) {
      alert(
        "Please fill in required fields: First Name, Last Name, and Phone Number",
      );
      return;
    }

    const tempPassword = "Patient@123";
    setIsCreatingPatient(true);

    try {
      const email =
        patientData.email || `${patientData.phoneNumber}@patient.com`;
      const newUserPayload = {
        username: email,
        first_name: patientData.firstName,
        last_name: patientData.lastName,
        email: email,
        mobile: patientData.phoneNumber,
        password: tempPassword,
        role: "Patient",
        app_status: "enabled",
      };

      const userCreationResponse = await userRegister(newUserPayload);

      if (!userCreationResponse || userCreationResponse.success !== 1) {
        throw new Error(
          userCreationResponse?.message ||
            "Patient registration failed. Please check your details.",
        );
      }

      setRegistrationComplete(true);
      setNewlyRegisteredEmail(email);
      getAllUsers();
    } catch (error) {
      setSuccessMessage(error.response?.data?.message || error.message);
      setIsCreatingPatient(false);
    }
  };

  const handleBookAppointment = async (patientId, patientName) => {
      if (!hasSelfAppointmentAddon) {
    alert("Unauthorized: Please subscribe to Self Appointment Addon.");
    return;
  }
    if (!hasSelfAppointmentAccess) {
      alert("Self Appointment feature is not available.");
      return;
    }

    // Yahan check badalna hai (selectedSlot -> selectedSlots.length)
    if (selectedSlots.length === 0) {
      alert("Please select at least one time slot");
      return;
    }

    if (!patientId) {
      alert("Please select a patient");
      return;
    }

    try {
      const appointmentFee = editableFee;

      // Loop chalayenge saare selected slots book karne ke liye
      for (const slot of selectedSlots) {
        const appointmentPayload = {
          PatientID: parseInt(patientId),
          hospitalID: parseInt(hospitalCode),
          appointmentDate: slot.date, // Purana selectedSlot.date yahan change hua
          appointmentTime: slot.time, // Purana selectedSlot.time yahan change hua
          type: appointmentType.toLowerCase(),
          paidAmount: appointmentFee,
          status: "Confirm",
          patient_name: patientName,
          appointmentBookedBy: "Doctor",
          bookingDate:
            new Date().toISOString().split("T")[0] +
            " " +
            new Date().toTimeString().split(" ")[0],
        };
        await createAppointment(appointmentPayload);
      }

      await getAllAppointments(hospitalCode);
      setSelectedSlots([]); // setSelectedSlot(null) ki jagah ye likhein
      setSelectedPatientId("");
      setSuccessMessage("All appointments booked successfully!");
      setTimeout(() => setSuccessMessage(""), 5000);
    } catch (error) {
      console.error("Appointment creation error:", error);
      alert("Failed to book appointments.");
    }
  };

  const handleBookForExistingPatient = async () => {
    if (!hasSelfAppointmentAccess) {
      alert("Access denied.");
      return;
    }

    if (!selectedPatientId) {
      alert("Please select a patient");
      return;
    }

    if (selectedSlots.length === 0) {
      alert("Please select at least one time slot");
      return;
    }

    const patientUser = patientUsers.find(
      (p) => String(getPatientUserId(p)) === String(selectedPatientId),
    );
    const patientName =
      `${patientUser.first_name || ""} ${patientUser.last_name || ""}`.trim();
    const finalPatientId = getPatientUserId(patientUser);

    try {
      // Loop through all selected slots
      for (const slot of selectedSlots) {
        const appointmentFee = editableFee;
        const appointmentPayload = {
          PatientID: parseInt(finalPatientId),
          hospitalID: parseInt(hospitalCode),
          appointmentDate: slot.date,
          appointmentTime: slot.time,
          type: appointmentType.toLowerCase(),
          paidAmount: appointmentFee,
          status: "Confirm",
          patient_name: patientName,
          appointmentBookedBy: "Doctor",
          bookingDate:
            new Date().toISOString().split("T")[0] +
            " " +
            new Date().toTimeString().split(" ")[0],
        };
        await createAppointment(appointmentPayload);
      }
        setShowConfirmModal(false); 
      await getAllAppointments(hospitalCode);
      setSelectedSlots([]); // Clear slots after booking
      setSelectedPatientId("");
      setSuccessMessage(
        `${selectedSlots.length} Appointments booked successfully!`,
      );
      setTimeout(() => setSuccessMessage(""), 5000);
    } catch (error) {
       setShowConfirmModal(false); // Error par bhi modal close karein
    alert("Failed to book some or all appointments.");
    }
  };
  // Show loading while checking access
  if (checkingAccess) {
    return (
      <div className="self-appointment-tab">
        <div className="text-center my-5">
          <div className="spinner-border text-info" role="status" />
          <p className="mt-2">
            Checking self appointment access permissions...
          </p>
        </div>
      </div>
    );
  }

  // Show access denied message for users without self appointment addon
  if (!hasSelfAppointmentAccess) {
    const userRole = localStorage.getItem("userRole");
if (!hasSelfAppointmentAddon) {
  return (
    <div className="text-center my-5 p-5 card shadow">
      <i className="fas fa-lock fa-4x text-warning mb-4"></i>
      <h3 className="font-weight-bold">Self Appointment Addon Required</h3>
      <p className="text-muted">You haven't subscribed to this feature yet.</p>
      <Link to="/doctor/plan-selection" className="btn btn-info rounded-pill">
        Upgrade Now
      </Link>
    </div>
  );
}
    return (
      <div className="self-appointment-tab">
        <div className="text-center my-5">
          <div
            className="alert alert-warning mx-auto"
            style={{ maxWidth: "600px" }}
          >
            <i className="fas fa-calendar-plus fa-3x mb-3 text-warning"></i>
            <h4>Self Appointment Feature Not Available</h4>
            <p className="mb-3">
              {userRole?.toLowerCase() === "admin"
                ? "The self appointment management feature requires the Self Appointment Addon Package. Please subscribe to this addon to create patients and book appointments directly."
                : "You do not have permission to access the self appointment management feature. Please contact your hospital administrator."}
            </p>
            {userRole?.toLowerCase() === "admin" && (
              <div>
                <button
                  className="btn btn-info me-2"
                  onClick={() =>
                    (window.location.href = "/#/doctor/plan-selection")
                  }
                >
                  <i className="fas fa-crown me-2"></i>
                  View Subscription Plans
                </button>
                <button
                  className="btn btn-outline-info"
                  onClick={() =>
                    (window.location.href = "/#/doctor/plan-selection")
                  }
                >
                  <i className="fas fa-puzzle-piece me-2"></i>
                  Browse Addons
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="self-appointment-tab">
      {successMessage && (
        <div
          className="alert alert-success alert-dismissible fade show mb-4"
          role="alert"
        >
          <i className="fas fa-check-circle mr-2"></i>
          {successMessage}
          <button
            type="button"
            className="close"
            onClick={() => setSuccessMessage("")}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      )}

      <div className="row">
        <div className="col-lg-4">
          {/* Patient Management Card */}
          <div className="card shadow-sm border-0 mb-4">
            <div className="card-headers filter-bar">
              <h5 className="card-title mb-0">
                <i className="fas fa-user-plus mr-2"></i>
                Patient Management
              </h5>
            </div>
            <div className="card-body">
              {!showPatientForm ? (
                <div className="text-center py-4">
                  <p className="text-muted mb-4">
                    Create a new patient to book an appointment
                  </p>
                  <button
                    className="btn btn-info rounded-pill btn-sm px-4"
                    onClick={() => setShowPatientForm(true)}
                    disabled={isCreatingPatient}
                  >
                    <i className="fas fa-plus mr-2"></i>
                    Create New Patient
                  </button>
                </div>
              ) : (
                <div className="patient-form p-3">
                  <div className="d-flex justify-content-between align-items-center mb-4 p-3">
                    <h6 className="mb-0 text-dark font-weight-bold">
                      New Patient Information
                    </h6>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => {
                        setShowPatientForm(false);
                        setPatientData({
                          firstName: "",
                          lastName: "",
                          email: "",
                          phoneNumber: "",
                        });
                      }}
                      disabled={isCreatingPatient}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </div>

                  <div className="form-group">
                    <label className="form-label font-weight-semibold">
                      First Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Enter first name"
                      value={patientData.firstName}
                      onChange={(e) =>
                        handlePatientInputChange("firstName", e.target.value)
                      }
                      required
                      disabled={isCreatingPatient}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label font-weight-semibold">
                      Last Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Enter last name"
                      value={patientData.lastName}
                      onChange={(e) =>
                        handlePatientInputChange("lastName", e.target.value)
                      }
                      required
                      disabled={isCreatingPatient}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label font-weight-semibold">
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      placeholder="Enter email (optional)"
                      value={patientData.email}
                      onChange={(e) =>
                        handlePatientInputChange("email", e.target.value)
                      }
                      disabled={isCreatingPatient}
                    />
                    <small className="form-text text-muted">
                      If not provided, a default email will be generated
                    </small>
                  </div>

                  <div className="form-group">
                    <label className="form-label font-weight-semibold">
                      Phone Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="tel"
                      className="form-control form-control-lg"
                      placeholder="Enter phone number"
                      value={patientData.phoneNumber}
                      onChange={(e) =>
                        handlePatientInputChange("phoneNumber", e.target.value)
                      }
                      required
                      disabled={isCreatingPatient}
                    />
                  </div>

                  <div className="d-flex gap-2 mt-4">
                    <button
                      type="button"
                      className="btn btn-info rounded-pill btn-sm "
                      onClick={handleCreatePatient}
                      disabled={isCreatingPatient}
                    >
                      {isCreatingPatient ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm mr-2"
                            role="status"
                          ></span>
                          Creating Patient...
                        </>
                      ) : (
                        <>Create Patient</>
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Quick Booking Card */}
          <div className="card shadow-sm border-0">
            <div className="card-header filter-bar">
              <h6 className="card-title mb-0">
                <i className="fas fa-user-injured mr-2"></i>
                Select Patient for Appointment
              </h6>
            </div>
            <div className="card-body p-3">
              {/* Search Section */}
              <div className="form-group">
                <label className="form-label font-weight-semibold">
                  <i className="fas fa-search mr-1"></i>
                  Search Patient
                </label>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text bg-light">
                      <i className="fas fa-search text-muted"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by name, phone, email, or ID..."
                    value={patientSearchTerm}
                    onChange={(e) => setPatientSearchTerm(e.target.value)}
                  />
                  {patientSearchTerm && (
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={() => setPatientSearchTerm("")}
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                  )}
                </div>
                <small className="form-text text-muted">
                  {patientUsers.length} patient records available
                </small>
              </div>

              {/* Patient Selection */}
              {/* <div className="form-group">
                <label className="form-label font-weight-semibold">
                  <i className="fas fa-user mr-1"></i>
                  Select Patient
                  <span className="text-danger ml-1">*</span>
                </label>

                {filteredPatientUsers.length === 0 ? (
                  <div className="alert alert-warning py-3 text-center">
                    <i className="fas fa-exclamation-triangle mr-2"></i>
                    {patientSearchTerm
                      ? "No patients found matching your search."
                      : "No patients available."}
                  </div>
                ) : (
                  <>
                    <select
                      className="form-control"
                      value={selectedPatientId}
                      onChange={(e) => setSelectedPatientId(e.target.value)}
                      disabled={isCreatingAppointment}
                    >
                      <option value="">-- Select a patient --</option>
                      {filteredPatientUsers.map((patientUser) => {
                        const patientId = getPatientUserId(patientUser);
                        return (
                          <option key={patientId} value={patientId}>
                            {getPatientUserDisplayInfo(patientUser)}
                          </option>
                        );
                      })}
                    </select>

                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <small className="form-text text-muted">
                        Showing {filteredPatientUsers.length} of{" "}
                        {patientUsers.length} patients
                      </small>
                      {filteredPatientUsers.length < patientUsers.length &&
                        patientSearchTerm && (
                          <small className="text-info">
                            <i className="fas fa-filter mr-1"></i>
                            Filtered
                          </small>
                        )}
                    </div>
                  </>
                )}
              </div> */}
                {/* Patient Selection & Search Results */}
<div className="form-group">
    <label className="form-label font-weight-semibold">
        <i className="fas fa-user mr-1"></i>
        Select Patient <span className="text-danger ml-1">*</span>
    </label>

    {filteredPatientUsers.length === 0 ? (
        <div className="alert alert-warning py-3 text-center">
            <i className="fas fa-exclamation-triangle mr-2"></i>
            {patientSearchTerm ? "No patients found matching your search." : "No patients available."}
        </div>
    ) : (
        <>
            {/* Jab search box me kuch likha ho, tab clickable list dikhayye */}
            {patientSearchTerm.length > 0 ? (
                <div className="search-results-list border rounded mb-2" style={{ maxHeight: '200px', overflowY: 'auto', backgroundColor: '#f9f9f9' }}>
                    {filteredPatientUsers.map((patientUser) => {
                        const pId = getPatientUserId(patientUser);
                        return (
                            <div 
                                key={pId}
                                className={`p-2 border-bottom cursor-pointer d-flex justify-content-between align-items-center ${selectedPatientId === String(pId) ? 'bg-info text-white' : 'hover-bg-light'}`}
                                onClick={() => setSelectedPatientId(String(pId))}
                                style={{ cursor: 'pointer' }}
                            >
                                <div>
                                    <div className="font-weight-bold" style={{ fontSize: '0.9rem' }}>
                                        {patientUser.first_name} {patientUser.last_name}
                                    </div>
                                    <div className="small" style={{ opacity: 0.8 }}>
                                        <i className="fas fa-phone-alt mr-1"></i> {patientUser.mobile || 'No Phone'}
                                    </div>
                                </div>
                                {selectedPatientId === String(pId) && <i className="fas fa-check-circle"></i>}
                            </div>
                        );
                    })}
                </div>
            ) : (
                /* Jab search box khali ho, tab normal dropdown dikhayye */
                <select
                    className="form-control"
                    value={selectedPatientId}
                    onChange={(e) => setSelectedPatientId(e.target.value)}
                    disabled={isCreatingAppointment}
                >
                    <option value="">-- Select a patient --</option>
                    {filteredPatientUsers.map((patientUser) => {
                        const patientId = getPatientUserId(patientUser);
                        return (
                            <option key={patientId} value={patientId}>
                                {patientUser.first_name} {patientUser.last_name} ({patientUser.mobile || 'No Phone'})
                            </option>
                        );
                    })}
                </select>
            )}

            {/* Filter Stats */}
            <div className="d-flex justify-content-between align-items-center mt-2">
                <small className="form-text text-muted">
                    Showing {filteredPatientUsers.length} of {patientUsers.length} patients
                </small>
                {patientSearchTerm && (
                    <button className="btn btn-link btn-sm p-0 text-info" onClick={() => setPatientSearchTerm('')}>
                        Clear Search
                    </button>
                )}
            </div>
        </>
    )}
</div>
              {/* Selected Patient Preview */}
              {selectedPatientId &&
                (() => {
                  const selectedPatient = filteredPatientUsers.find(
                    (p) =>
                      String(getPatientUserId(p)) === String(selectedPatientId),
                  );
                  return selectedPatient ? (
                    <div className="alert alert-light border mt-3">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-user-check mr-3 text-success"></i>
                        <div className="flex-grow-1">
                          <strong className="text-dark">
                            Selected Patient:
                          </strong>
                          <div className="mt-1">
                            <div className="font-weight-semibold text-dark">
                              {selectedPatient.first_name}{" "}
                              {selectedPatient.last_name}
                            </div>
                            <div className="small text-muted">
                              <span className="mr-3">
                                <i className="fas fa-phone mr-1"></i>
                                {selectedPatient.mobile || "N/A"}
                              </span>
                              <span className="mr-3">
                                <i className="fas fa-envelope mr-1"></i>
                                {selectedPatient.email || "N/A"}
                              </span>
                              <span>
                                <i className="fas fa-id-card mr-1"></i>
                                {getPatientUserId(selectedPatient)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null;
                })()}
              {/* Selected Patient Preview - Iske niche ye list add karein */}
              {selectedPatientId &&
                (() => {
                  const selectedPatient = filteredPatientUsers.find(
                    (p) =>
                      String(getPatientUserId(p)) === String(selectedPatientId),
                  );
                  return selectedPatient ? (
                    <>
                      {selectedSlots.length > 0 && (
                        <div className="mt-3 p-2 border rounded bg-white shadow-sm">
                          <h6 className="font-weight-bold text-info border-bottom pb-2">
                            <i className="fas fa-list-ul mr-2"></i>
                            Selected Slots ({selectedSlots.length})
                          </h6>
                          <div
                            style={{ maxHeight: "200px", overflowY: "auto" }}
                          >
                            {selectedSlots.map((slot, index) => (
                              <div
                                key={index}
                                className="d-flex justify-content-between align-items-center p-2 mb-1 bg-light rounded border-left border-info"
                                style={{ borderLeftWidth: "4px" }}
                              >
                                <div className="small">
                                  <div className="font-weight-bold text-dark">
                                    {new Date(slot.date).toLocaleDateString(
                                      "en-US",
                                      { day: "2-digit", month: "short" },
                                    )}
                                  </div>
                                  <div className="text-muted">{slot.time}</div>
                                </div>
                                <button
                                  className="btn btn-sm text-danger p-0 px-2"
                                  onClick={() =>
                                    toggleSlotSelection(slot.date, slot.time)
                                  }
                                >
                                  <i className="fas fa-times-circle"></i>
                                </button>
                              </div>
                            ))}
                          </div>

                          <button
  className="btn btn-info btn-sm w-100 mt-3 py-2 font-weight-bold"
  onClick={() => setShowConfirmModal(true)} // Pehle logic call hota tha, ab modal open hoga
  disabled={isCreatingAppointment || selectedSlots.length === 0}
>
  Confirm {selectedSlots.length} Appointment(s)
</button>
                        </div>
                      )}
                    </>
                  ) : null;
                })()}
            </div>
          </div>
        </div>

        <div className="col-lg-8">
          {/* Schedule Picker Card */}
          <div className="card shadow-sm border-0 h-100">
            <div className="card-headers filter-bar">
              <h5 className="card-title mb-0">
                <i className="fas fa-calendar-alt mr-2"></i>
                Select Appointment Slot
              </h5>
            </div>
            <div className="card-body">
              <div className="row mb-4 p-3">
  <div className="col-12">
    <label className="form-label h6 font-weight-semibold mb-3">
      Appointment Type & Consultation Fee
    </label>

    <div className="appointment-options-list">
      
      {/* 1. Direct Consult */}
      <div className="form-check d-flex align-items-center mb-2">
        <input
          type="radio"
          className="form-check-input mt-0"
          id="directConsult"
          name="appointmentType"
          value="Direct"
          checked={appointmentType === "Direct"}
          onChange={(e) => setAppointmentType(e.target.value)}
          disabled={isCreatingAppointment}
        />
        <label className="form-check-label d-flex align-items-center ml-2 mb-0" htmlFor="directConsult" style={{ cursor: 'pointer' }}>
          <i className="fas fa-clinic-medical mr-2 text-primary" style={{ fontSize: '14px' }}></i>
          <span className="mr-2 font-weight-bold" style={{ fontSize: '14px' }}>Direct Consult:</span>
          
          <div className="input-group input-group-sm" style={{ maxWidth: '100px' }}>
            <div className="input-group-prepend">
              <span 
                className="input-group-text bg-white" 
                style={{ height: '28px', padding: '0 8px', fontSize: '12px', display: 'flex', alignItems: 'center' }}
              >₹</span>
            </div>
            <input
              type="number"
              className={`form-control form-control-sm font-weight-bold ${appointmentType === "Direct" ? 'border-info' : ''}`}
              style={{ height: '28px', padding: '0 8px', fontSize: '12px'  }}
              value={appointmentType === "Direct" ? editableFee : (doctorProfile?.PricingOffline || "0")}
              onChange={(e) => {
                setAppointmentType("Direct");
                setEditableFee(e.target.value);
              }}
              disabled={isCreatingAppointment}
            />
          </div>
        </label>
      </div>

    {/* 2. Video Consult */}
<div className="form-check d-flex align-items-center mb-2">
  <input
    type="radio"
    className="form-check-input mt-0"
    id="videoConsult"
    name="appointmentType"
    value="Video"
    checked={appointmentType === "Video" && hasVideoAddon}
    onChange={() => handleTypeSelection("Video", hasVideoAddon)}
    disabled={!hasVideoAddon || isCreatingAppointment}
  />

  <label
    className={`form-check-label d-flex align-items-center ml-2 mb-0 ${!hasVideoAddon ? 'text-muted' : ''}`}
    htmlFor="videoConsult"
    style={{ cursor: hasVideoAddon ? 'pointer' : 'not-allowed' }}
  >
    <i className="fas fa-video mr-2 text-success" style={{ fontSize: '14px' }}></i>
    <span className="mr-2 font-weight-bold" style={{ fontSize: '14px' }}>
      Video Consult:
    </span>

    <div className="input-group input-group-sm" style={{ maxWidth: '100px' }}>
      <div className="input-group-prepend">
        <span
          className="input-group-text bg-white"
          style={{
            height: '28px',
            padding: '0 8px',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          ₹
        </span>
      </div>

      <input
        type="number"
        className={`form-control form-control-sm font-weight-bold ${
          appointmentType === "Video" ? 'border-info' : ''
        }`}
        style={{ height: '28px', padding: '0 8px', fontSize: '12px' }}
        value={
          appointmentType === "Video"
            ? editableFee
            : doctorProfile?.PricingVideo || "0"
        }
        onChange={(e) => {
          setAppointmentType("Video");
          setEditableFee(e.target.value);
        }}
        disabled={!hasVideoAddon || isCreatingAppointment}
      />
    </div>
  </label>
</div>
{/* 3. Home Visit */}
<div className="form-check d-flex align-items-center mb-2">
  <input
    type="radio"
    className="form-check-input mt-0"
    id="homeConsult"
    name="appointmentType"
    value="Home"
    checked={appointmentType === "Home" && hasHomeVisitAddon}
    onChange={() => handleTypeSelection("Home", hasHomeVisitAddon)}
    disabled={!hasHomeVisitAddon || isCreatingAppointment}
  />

  <label
    className={`form-check-label d-flex align-items-center ml-2 mb-0 ${!hasHomeVisitAddon ? 'text-muted' : ''}`}
    htmlFor="homeConsult"
    style={{ cursor: hasHomeVisitAddon ? 'pointer' : 'not-allowed' }}
  >
    <i className="fas fa-home mr-2 text-warning" style={{ fontSize: '14px' }}></i>
    <span className="mr-2 font-weight-bold" style={{ fontSize: '14px' }}>
      Home Consult:
    </span>

    <div className="input-group input-group-sm" style={{ maxWidth: '100px' }}>
      <div className="input-group-prepend">
        <span
          className="input-group-text bg-white"
          style={{
            height: '28px',
            padding: '0 8px',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          ₹
        </span>
      </div>

      <input
        type="number"
        className={`form-control form-control-sm font-weight-bold ${
          appointmentType === "Home" ? 'border-info' : ''
        }`}
        style={{ height: '28px', padding: '0 8px', fontSize: '12px' }}
        value={
          appointmentType === "Home"
            ? editableFee
            : doctorProfile?.HomeVisitPricingOnline || "0"
        }
        onChange={(e) => {
          setAppointmentType("Home");
          setEditableFee(e.target.value);
        }}
        disabled={!hasHomeVisitAddon || isCreatingAppointment}
      />
    </div>
  </label>
</div>
    </div>

    {/* Information Message */}
    <div className="mt-3 p-2 bg-light rounded small text-muted border-left border-info" style={{ borderLeftWidth: '4px' }}>
      <i className="fas fa-info-circle mr-1 text-info"></i>
      Prices are pre-filled. You can edit them if additional services were provided.
    </div>
  </div>
</div>

              {/* Week Navigation */}
              <div className="schedule-header mb-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <button
                    className="btn btn-outline-info"
                    onClick={() => setWeekOffset(weekOffset - 1)}
                    disabled={weekOffset <= 0 || isCreatingAppointment}
                  >
                    <i className="fas fa-chevron-left mr-2"></i>
                  </button>
                  <h6 className="mb-0 text-dark font-weight-bold text-center mx-3">
                    {selectedDateInfo
                      ? new Date(selectedDateInfo.fullDate).toLocaleDateString(
                          "en-US",
                          {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          },
                        )
                      : "Select a date to view available slots"}
                  </h6>
                  <button
                    className="btn btn-outline-info"
                    onClick={() => setWeekOffset(weekOffset + 1)}
                    disabled={isCreatingAppointment}
                  >
                    <i className="fas fa-chevron-right ml-2"></i>
                  </button>
                </div>

                {/* Days Grid - Fixed Equal Sizes */}
                <div className="row">
                  {weekDays.map((day) => (
                    <div key={day.fullDate} className="col p-1">
                      <button
                        className={`btn w-100 h-100 d-flex flex-column justify-content-center align-items-center p-0 ${
                          selectedDateInfo?.fullDate === day.fullDate
                            ? "btn-info text-white"
                            : day.isPast
                              ? "btn-light text-muted"
                              : "btn-outline-info"
                        }`}
                        onClick={() => {
                          if (!day.isPast && !isCreatingAppointment) {
                            setSelectedDateInfo(day);
                          }
                        }}
                        disabled={day.isPast || isCreatingAppointment}
                        style={{ minHeight: "120px" }}
                      >
                        <div className="small font-weight-bold mb-1">
                          {day.dayName}
                        </div>
                        <div className="h5 font-weight-bold mb-1">
                          {day.dateStr.split(" ")[0]}
                        </div>
                        <div className="small text-uppercase mb-2">
                          {day.dateStr.split(" ")[1]}
                        </div>
                        <div className="small">
                          {day.isPast ? (
                            <span className="badge badge-secondary">Past</span>
                          ) : (
                            <span
                              className={`badge ${
                                (calculateSlotsForDay(day) || []).length === 0
                                  ? "badge-warning"
                                  : "badge-success"
                              }`}
                            >
                              {(calculateSlotsForDay(day) || []).length === 0
                                ? "No Slots"
                                : `${(calculateSlotsForDay(day) || []).length}`}
                            </span>
                          )}
                        </div>
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              {/* Time Slots */}
              <div className="schedule-cont">
                {availableSlots.length > 0 ? (
                  <div className="time-slot-container">
                    {categorizedSlots.morning.length > 0 && (
                      <div className="time-slot-group mb-4">
                        <h6 className="border-bottom pb-2 mb-3 text-info font-weight-semibold">
                          <i className="far fa-sun mr-2 text-warning"></i>
                          Morning Slots
                        </h6>
                        <div className="row">
                          {categorizedSlots.morning.map((slot, idx) => (
                            <div
                              key={`m-${idx}`}
                              className="col-6 col-md-4 col-lg-3 mb-2"
                            >
                              <button
                                className={`btn w-100 ${
                                  // Check karein ki ye slot array mein hai ya nahi
                                  selectedSlots.some(
                                    (s) =>
                                      s.time === slot.slot &&
                                      s.date === selectedDateInfo?.fullDate,
                                  )
                                    ? "btn-success rounded-pill text-white"
                                    : "btn-info rounded-pill"
                                }`}
                                onClick={() =>
                                  toggleSlotSelection(
                                    selectedDateInfo.fullDate,
                                    slot.slot,
                                  )
                                }
                                disabled={isCreatingAppointment}
                              >
                                {slot.slot}
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {categorizedSlots.afternoon.length > 0 && (
                      <div className="time-slot-group mb-4">
                        <h6 className="border-bottom pb-2 mb-3 text-info font-weight-semibold">
                          <i className="fas fa-sun mr-2 text-orange"></i>
                          Afternoon Slots
                        </h6>
                        <div className="row">
                          {categorizedSlots.afternoon.map((slot, idx) => (
                            <div
                              key={`a-${idx}`}
                              className="col-6 col-md-4 col-lg-3 mb-2"
                            >
                              <button
                                className={`btn w-100 ${
                                  // Check karein ki ye slot array mein hai ya nahi
                                  selectedSlots.some(
                                    (s) =>
                                      s.time === slot.slot &&
                                      s.date === selectedDateInfo?.fullDate,
                                  )
                                    ? "btn-success rounded-pill text-white"
                                    : "btn-info rounded-pill"
                                }`}
                                onClick={() =>
                                  toggleSlotSelection(
                                    selectedDateInfo.fullDate,
                                    slot.slot,
                                  )
                                }
                                disabled={isCreatingAppointment}
                              >
                                {slot.slot}
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {categorizedSlots.evening.length > 0 && (
                      <div className="time-slot-group">
                        <h6 className="border-bottom pb-2 mb-3 text-info font-weight-semibold">
                          <i className="far fa-moon mr-2 text-dark"></i>Evening
                          Slots
                        </h6>
                        <div className="row">
                          {categorizedSlots.evening.map((slot, idx) => (
                            <div
                              key={`e-${idx}`}
                              className="col-6 col-md-4 col-lg-3 mb-2"
                            >
                              <button
                                className={`btn w-100 ${
                                  // Check karein ki ye slot array mein hai ya nahi
                                  selectedSlots.some(
                                    (s) =>
                                      s.time === slot.slot &&
                                      s.date === selectedDateInfo?.fullDate,
                                  )
                                    ? "btn-success rounded-pill text-white"
                                    : "btn-info rounded-pill"
                                }`}
                                onClick={() =>
                                  toggleSlotSelection(
                                    selectedDateInfo.fullDate,
                                    slot.slot,
                                  )
                                }
                                disabled={isCreatingAppointment}
                              >
                                {slot.slot}
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <i className="fas fa-calendar-times fa-3x text-muted mb-3"></i>
                    <h5 className="text-muted font-weight-semibold">
                      {selectedDateInfo
                        ? "No available slots for this day."
                        : "Please select a date to see available slots."}
                    </h5>
                    <p className="text-muted">
                      Choose a different date or check back later for new slots.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <MessageModal
        show={showConfirmModal}
        onClose={() => !isCreatingAppointment && setShowConfirmModal(false)}
        onConfirm={handleBookForExistingPatient}
        title="Confirm Booking"
        message={`Are you sure you want to book ${selectedSlots.length} appointment(s) for this patient?`}
        variant="info"
        showConfirm={true}
        confirmText="Confirm & Book"
        cancelText="Cancel"
        loading={isCreatingAppointment}
      />
      <MessageModal
  show={showAddonModal}
  onClose={() => setShowAddonModal(false)}
  title="Access Restricted"
  variant="warning"
  showConfirm={true}
  confirmText={<span><i className="fas fa-crown me-2"></i> Subscribe Now</span>}
  onConfirm={() => {
    setShowAddonModal(false);
    window.location.href = "/#/doctor/plan-selection"; 
  }}
  message={
    <div className="alert alert-warning border-0 p-0 mb-0" style={{ background: 'transparent' }}>
      <div className="d-flex align-items-center">
        <i className="fas fa-calendar-check text-warning me-3" style={{ fontSize: '3rem' }}></i>
        <div className="text-start text-dark">
          <strong className="h5 d-block mb-1">{missingAddonName} Addon Required!</strong>
          <p className="mb-0 small text-muted">
            You have not subscribed to the {missingAddonName} Addon. 
            Please select a plan to enable this consultation feature.
          </p>
        </div>
      </div>
    </div>
  }
/>
    </div>
  );
};

const mapStateToProps = (state) => ({
  templateSlots: state.schedule?.templateSlots || [],
  daysOff: state.schedule?.daysOff || [],
  blockers: state.schedule?.blockers || [],
  bookedAppointments: state.appointment?.all || [],
  userList: Array.isArray(state.loginReducer?.userList?.data)
    ? state.loginReducer.userList.data
    : [],
  doctorProfile: state.doctorProfile?.profileData || null,
  accountStatus: state.businessModule?.accountStatus,
    businessAddons: state.businessAddons?.businessAddons || [],
});

const mapDispatchToProps = {
  userRegister,
  getAllUsers,
  setPatientProfile,
  createAppointment,
  getScheduleData,
  getAllAppointments,
  getAllPatientProfiles,
  getDoctorProfileById,
  getAccountStatus,
   getBusinessAddons,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfAppointmentTab);
